import {CacheableDataObject} from '../models/CacheableDataObject.jsx'

class MatchStocks extends CacheableDataObject
{

}
export {MatchStocks};